/**
 * PDF design tokens — PDF-local source of truth.
 *
 * Decoupled from src/shared/designTokens.js as of Sub-piece 10D-1/Sub-1
 * so the PDF visual contract can evolve independently of the dashboard.
 * The dashboard continues to import from src/shared/designTokens.js.
 * @module pdf/designTokens
 */

export const COLORS = {
  navyDark: '#0B1F36',
  navy: '#0F2B46',
  navyLight: '#163D5C',
  teal: '#1A9E8F',
  tealLight: '#E8F8F5',
  tealHover: '#168A7D',
  white: '#FFFFFF',

  critical: '#C0392B',
  criticalBg: '#FDEDEC',
  warning: '#D4880F',
  warningBg: '#FEF5E7',
  pass: '#1E8449',
  passBg: '#EAFAF1',

  gray50: '#FAFBFC',
  gray100: '#F8F9FA',
  gray200: '#DEE2E6',
  gray300: '#CED4DA',
  gray350: '#ADB5BD',
  gray400: '#6C757D',
  gray600: '#495057',
  gray800: '#212529',

  textPrimary: '#1A1A2E',
  textSecondary: '#6C757D',

  bg: '#F4F5F7',
};

export const FONT_TOKENS = {
  family: "'Poppins', sans-serif",
  weights: { light: 300, regular: 400, medium: 500, semibold: 600, bold: 700, extrabold: 800 },
};

export const PAGE = {
  format: 'A4',
  widthMm: 210,
  heightMm: 297,
  marginTopMm: 0,
  marginBottomMm: 18,
  marginLeftMm: 18,
  marginRightMm: 18,
};

export function scoreColor(score) {
  if (score >= 80) return COLORS.pass;
  if (score >= 55) return COLORS.warning;
  return COLORS.critical;
}

export function severityColor(severity) {
  switch (severity) {
    case 'CRITICAL': return COLORS.critical;
    case 'WARNING':  return COLORS.warning;
    case 'LOW':      return COLORS.pass;
    default:         return COLORS.gray400;
  }
}

export function verdictColor(verdict) {
  switch (verdict) {
    case 'APPROVED':             return COLORS.pass;
    case 'CORRECTIONS REQUIRED': return COLORS.warning;
    case 'REJECTED':             return COLORS.critical;
    default:                     return COLORS.gray400;
  }
}

export function verdictBg(verdict) {
  switch (verdict) {
    case 'APPROVED':             return COLORS.passBg;
    case 'CORRECTIONS REQUIRED': return COLORS.warningBg;
    case 'REJECTED':             return COLORS.criticalBg;
    default:                     return COLORS.gray100;
  }
}
